import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    List,
    ListItem,
    Avatar,
    Button,
    Box,
    ListItemButton,
    ListItemAvatar,
    Skeleton
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { baseUrl, get } from "../../services/api-services";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
const DashboardEnroll = ({ parentLoading }) => {
    const nav = useNavigate();
    const [recentlyEnrolledPrograms, setRecentlyEnrolledPrograms] = useState([]);
    const [totalEnrolled, setTotalEnrolled] = useState(0);
    const [allPrograms, setAllPrograms] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState("");
    const [loading, setLoading] = useState(true);

    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedProgram(value);
        fetchRecentlyEnrolledPrograms(value);
    };
    const onGetAllPrograms = async () => {
        const res = await get('/Programs');
        if (res?.statusCode === 200) {
            setAllPrograms(res?.data);
        }
    }
    // Fetch total enroll count
    const fetchTotalEnroll = async () => {
        try {
            const url = `/UserPrograms?filter={"where":{"status":"active"},"include":[{"relation":"invoice"},{"relation":"customer","scope":{"include":"payments"}}],"order":"createdAt DESC"}`;
            const response = await get(url);
            const activePrograms = response?.data.filter((item) => item.customer);
            setTotalEnrolled(activePrograms?.length);
        } catch (error) {
            console.error("Error fetching total enroll count:", error);
        }
    };

    const fetchRecentlyEnrolledPrograms = async (programId) => {
        setLoading(true);
        try {
            const whereFilter = {
                status: "active",
                ...(programId && programId !== "all" && { programId: programId })
            };
            const filter = {
                where: whereFilter,
                include: ["customer", "invoice"],
                order: "createdAt DESC",
                limit: 5,
            };
            const response = await get(`/UserPrograms?filter=${encodeURIComponent(JSON.stringify(filter))}`);
            setRecentlyEnrolledPrograms(response?.data);
        } catch (error) {
            console.error("Error fetching recently enrolled programs:", error);
        }
        setLoading(false);
    };

    // Avoid accessing array props directly.
    
    // Fetch both data on mount
    useEffect(() => {
        fetchRecentlyEnrolledPrograms();
        fetchTotalEnroll();
        onGetAllPrograms();
    }, []);

    const handleClick = () => {
        nav("/admin/sales");
    };

    return (
        <Card className="flex flex-col flex-1 mt-[20px]">
            <CardContent className="flex flex-col flex-1 relative">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle1" className=" font-bold">Recently Enrolled Programs</Typography>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                        <InputLabel id="demo-simple-select-standard-label">Enrolled In</InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={selectedProgram}
                            onChange={handleChange}
                            label="Enrolled In"
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 200, 
                                        overflowY: 'auto',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="all">All</MenuItem>
                            {allPrograms?.map((item) => (
                                <MenuItem key={item?.id} value={item?.id}>
                                    {item?.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </Box>

                <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                    {loading || parentLoading ? (
                        Array.from({ length: 4 }).map((_, i) => (
                            <ListItem key={i}>
                                <ListItemButton>
                                    <ListItemAvatar>
                                        <Skeleton variant="circular" width={40} height={40} animation="wave" />
                                    </ListItemAvatar>
                                    <Box sx={{ flex: 1 }}>
                                        <Skeleton variant="text" width="60%" animation="wave" />
                                        <Skeleton variant="text" width="40%" animation="wave" />
                                    </Box>
                                </ListItemButton>
                            </ListItem>
                        ))
                    ) : Array.isArray(recentlyEnrolledPrograms) && recentlyEnrolledPrograms.length > 0 ? (
                        recentlyEnrolledPrograms.map((program) => {
                            return (
                                
                                <ListItem key={program?.id} onClick={() => { nav(`/admin/cases/caseDetails/${program?.customerId}`) }}>
                                    {/* Avatar with program icon */}
                                    <ListItemButton>
                                        <Box alignItems="flex-start">
                                            <ListItemAvatar>
                                                <Avatar
                                                    src={program?.customer?.image ? `${baseUrl}/Uploads/profile-pic/download/${program?.customer?.image}"` : "/assets/userProfile.png"}
                                                    alt={program?.customer?.name}
                                                />
                                            </ListItemAvatar>
                                        </Box>
                                        <Box>
                                            <Typography variant="body1">
                                                {program?.customer?.name || "Anonymous"}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" >
                                                WeightWonder™ {program?.invoice?.purchaseProgram?.title || "Unknown Program"}
                                            </Typography>
                                        </Box>
                                    </ListItemButton>
                                </ListItem>
                            )
                        })
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No recent enrollments found.
                        </Typography>
                    )}
                </List>

                {/* Button with total enrolled count */}
                <Box display="flex" justifyContent="flex-start" className="absolute left-2  bottom-2">
                    <Button color="primary" onClick={handleClick}
                        sx={{ textTransform: 'none' }}
                        className="max-w-[200px]" endIcon={<ChevronRightOutlinedIcon />}>
                        {totalEnrolled} total enrolled
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default DashboardEnroll;
